import React, { useEffect } from "react";
import { connect } from "react-redux";
import SimulateStats from "../../components/ResultPage";

const FinishedSimulate = (props) => {

    return (
        <SimulateStats data={props} componente={'finished'}/>
    )
}

const mapStateToProps = state => (
    {
        result: state.exam.result
    }
);

export default connect(mapStateToProps, {})(FinishedSimulate);